import Vue from 'vue'
import VueNativeSock from 'vue-native-websocket'
import store from '@/state/store'

Vue.use(VueNativeSock, `${process.env.VUE_APP_WS_URL}`, {
  store: store,
  format: 'json',
  connectManually: true,
})

let interval = null
const vm = new Vue()

const connectWS = (url) => {
  vm.$connect(url)
  interval = setInterval(() => {
    try {
      if (vm.$socket?.readyState == 1) {
        vm.$socket.send('PING')
      }
    } catch (e) {
      console.error(e)
    }
  }, 2000)
}

const disconnectWS = () => {
  vm.$disconnect()
  clearInterval(interval)
}

export const state = {
  socket: {
    isConnected: false,
    message: '',
    reconnectError: false,
  },
}

export const actions = {
  WSConnect(ctx, url) {
    connectWS(url)
  },
  WSDisconnect() {
    disconnectWS()
  },
}

